/** A placeholder must be the entire value of its slot, and match this name shape. */
export const PLACEHOLDER_PATTERN = /^\{\{([a-z][a-z0-9_]*)\}\}$/;

export function placeholderName(value: string): string | undefined {
  return PLACEHOLDER_PATTERN.exec(value)?.[1];
}
